/**
 * Ícones contextuais baseados no tipo de aplicação
 * Cada contexto tem seu próprio ícone representativo
 */

import { UnitContext } from '@/lib/types';

interface ContextIconProps {
  context: UnitContext
  className?: string
}

const contextIcons: Record<UnitContext, () => JSX.Element> = {
  // Fazenda - Vaca
  farm: () => (
    <g>
      {/* Chifre esquerdo */}
      <path d="M9.36,4.34a4.8,4.8,0,0,1-2.11-1.06,9.18,9.18,0,0,1-1.35-1.59.53.53,0,0,0-.93.12A5.88,5.88,0,0,0,4.6,4.6a4.66,4.66,0,0,0,1.58,2.64Z" fill="#fff48c"/>
      <path d="M9.36,4.34a4.8,4.8,0,0,1-2.11-1.06,9.18,9.18,0,0,1-1.35-1.59.53.53,0,0,0-.93.12A5.88,5.88,0,0,0,4.6,4.6a4.66,4.66,0,0,0,1.58,2.64Z" fill="none" stroke="#45413c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5"/>
      {/* Chifre direito */}
      <path d="M14.64,4.34a4.8,4.8,0,0,0,2.11-1.06,9.18,9.18,0,0,0,1.35-1.59.53.53,0,0,1,.93.12A5.88,5.88,0,0,1,19.4,4.6a4.66,4.66,0,0,1-1.58,2.64Z" fill="#fff48c"/>
      <path d="M14.64,4.34a4.8,4.8,0,0,0,2.11-1.06,9.18,9.18,0,0,0,1.35-1.59.53.53,0,0,1,.93.12A5.88,5.88,0,0,1,19.4,4.6a4.66,4.66,0,0,1-1.58,2.64Z" fill="none" stroke="#45413c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5"/>
      {/* Orelha esquerda */}
      <path d="M6.37,6.17s-3.5.47-5,4.5c-0.97,2.55,5,1.32,5,1.32Z" fill="#f0f0f0"/>
      <path d="M6.37,6.17s-3.5.47-5,4.5c-0.97,2.55,5,1.32,5,1.32Z" fill="none" stroke="#45413c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5"/>
      {/* Orelha direita */}
      <path d="M17.62,6.17s3.5.47,5,4.5c0.97,2.55-5,1.32-5,1.32Z" fill="#f0f0f0"/>
      <path d="M17.62,6.17s3.5.47,5,4.5c0.97,2.55-5,1.32-5,1.32Z" fill="none" stroke="#45413c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5"/>
      {/* Cabeça */}
      <rect x="5.4" y="4.07" width="13.2" height="12.16" rx="4.77" fill="#f0f0f0"/>
      <path d="M13.83,4.07H10.16a4.77,4.77,0,0,0-4.77,4.77v1.91A4.77,4.77,0,0,1,10.16,6h3.67a4.77,4.77,0,0,1,4.77,4.77V8.84A4.77,4.77,0,0,0,13.83,4.07Z" fill="#fff"/>
      <rect x="5.4" y="4.07" width="13.2" height="12.16" rx="4.77" fill="none" stroke="#45413c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5"/>
      {/* Focinho */}
      <ellipse cx="12" cy="16.23" rx="7.66" ry="5.02" fill="#ffccdd"/>
      <path d="M12,13.06c5.83,0,7.31,1.7,7.6,4a6.1,6.1,0,0,0,.06-.8c0-2.77-0.97-5-7.66-5s-7.66,2.24-7.66,5a6.1,6.1,0,0,0,.06.8C4.69,14.76,6.17,13.06,12,13.06Z" fill="#ffe5ee"/>
      <ellipse cx="12" cy="16.23" rx="7.66" ry="5.02" fill="none" stroke="#45413c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5"/>
      {/* Narinas */}
      <circle cx="8.83" cy="16.76" r="0.8" fill="#ff87af"/>
      <circle cx="15.17" cy="16.76" r="0.8" fill="#ff87af"/>
      {/* Olhos */}
      <circle cx="15.36" cy="9.28" r="0.71" fill="#45413c"/>
      <circle cx="8.64" cy="9.28" r="0.71" fill="#45413c"/>
      {/* Bochechas */}
      <ellipse cx="17.28" cy="10.68" rx="0.8" ry="0.5" fill="#ffccdd"/>
      <ellipse cx="6.7" cy="10.68" rx="0.8" ry="0.5" fill="#ffccdd"/>
    </g>
  ),

  // Loja - Sacola de compras
  store: () => (
    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
  ),

  // Armazém - Caixas empilhadas
  warehouse: () => (
    <>
      <path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V8h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2z" />
    </>
  ),

  // Clínica - Cruz médica/Saúde
  clinic: () => (
    <>
      <path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z" />
    </>
  ),

  // Ótica - Óculos
  optical: () => (
    <>
      <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </>
  ),

  // Empresa - Prédio corporativo
  company: () => (
    <>
      <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
    </>
  ),

  // Unidade genérica - Cubo/Grid
  unit: () => (
    <>
      <path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z" />
    </>
  ),

  // Minerais - Cristal mineral com estrutura 3D e base geológica
  minerals: () => (
    <>
      {/* Estrutura cristalina 3D */}
      <path fillRule="evenodd" clipRule="evenodd" d="M11.7899 3.5463C11.9232 3.48457 12.0768 3.48457 12.2101 3.5463L17.2101 5.86209C17.3869 5.94395 17.5 6.12101 17.5 6.31579V12.1053C17.5 12.2837 17.4049 12.4486 17.2505 12.538L12.2505 15.4327C12.0956 15.5224 11.9044 15.5224 11.7495 15.4327L6.74948 12.538C6.59507 12.4486 6.5 12.2837 6.5 12.1053V6.31579C6.5 6.12101 6.61312 5.94395 6.78987 5.86209L11.7899 3.5463ZM7.5 7.12608L11.5 9.13309V14.1328L7.5 11.817V7.12608ZM12.5 14.1328L16.5 11.817V7.12608L12.5 9.13309V14.1328ZM12 8.26515L15.8492 6.33381L12 4.55103L8.15081 6.33381L12 8.26515Z" fill="currentColor"/>
      {/* Camadas geológicas */}
      <path d="M19.9903 14.9019C19.9612 14.7563 19.8688 14.6311 19.7381 14.5604C19.6075 14.4896 19.4522 14.4806 19.3143 14.5358L16.8143 15.5358C16.5579 15.6383 16.4332 15.9293 16.5358 16.1857C16.6383 16.4421 16.9293 16.5668 17.1857 16.4642L18.4099 15.9745C18.2077 16.5108 17.6606 17.0604 16.7261 17.5277C15.5424 18.1195 13.8722 18.5 12 18.5C10.1278 18.5 8.45755 18.1195 7.27386 17.5277C6.06026 16.9209 5.5 16.1751 5.5 15.5C5.5 15.2239 5.27614 15 5 15C4.72386 15 4.5 15.2239 4.5 15.5C4.5 16.7579 5.50674 17.7621 6.82665 18.4221C8.17646 19.097 10.0062 19.5 12 19.5C13.9938 19.5 15.8235 19.097 17.1734 18.4221C18.1301 17.9437 18.9223 17.2844 19.2858 16.4787L19.5097 17.5981C19.5639 17.8688 19.8273 18.0444 20.0981 17.9903C20.3688 17.9361 20.5444 17.6727 20.4903 17.4019L19.9903 14.9019Z" fill="currentColor"/>
    </>
  ),

    // Billing — frasco financeiro + pilha de moedas + símbolo monetário
  billing: () => (
    <>
      <g>
        <path fill="#c1ecfb" d="M29.23,29.63a12.3,12.3,0,0,1-4.12,8.67,10.887,10.887,0,0,1-6.34,2.67c-.41.04-.73.05-.93.05H17.6c-.62.06-1.93,0-2.58,0C7.15,41.02.78,36.48.78,29.19c0-5.56,3.7-13.39,8.93-16.82.16-.11.33-.21.49-.31a1.678,1.678,0,0,0,.66-.69,1.469,1.469,0,0,0,.07-1.23,1.227,1.227,0,0,0-.12-.26c-.14-.23-.28-.48-.44-.74C8.87,6.55,6.82,2.6,8.41,2.6c2.35,0,4.17,1.01,6.69,1.01S18.72,2.6,21.63,2.6c1.96,0-.18,3.95-1.79,6.54-.17.27-.33.53-.48.76-.05.08-.09.16-.13.24a1.506,1.506,0,0,0,.03,1.23,1.686,1.686,0,0,0,.68.75c.13.08.27.17.4.25,4.32,2.84,7.48,8.72,8.59,13.79.07.34.13.67.19,1,.02.14.04.29.06.43A12.508,12.508,0,0,1,29.23,29.63Z" />
        <path fill="#f6cc7c" d="M47.25,18.45V36.03c0,1.57-4.2,2.85-9.38,2.85S28.5,37.6,28.5,36.03V18.45c0,1.57,4.2,2.85,9.37,2.85S47.25,20.02,47.25,18.45Z" />
        <ellipse cx="37.874" cy="18.454" fill="#ffb963" rx="9.376" ry="2.844" />
        <path fill="#fcac44" d="M35.68,36.07v.23a9.1,9.1,0,1,1-9.1-9.09,8.69,8.69,0,0,1,1.92.21c.02,0,.03,0,.04.01a9.029,9.029,0,0,1,3.81,1.84,8.829,8.829,0,0,1,.71.65,8.972,8.972,0,0,1,1.81,2.65,4.987,4.987,0,0,1,.23.53,9.01,9.01,0,0,1,.55,2.45C35.66,35.72,35.67,35.9,35.68,36.07Z" />
      </g>

      <g>
        <path fill="#1a1a1a" d="M26.578,26.456a9.85,9.85,0,0,0-4.923,1.316.75.75,0,1,0,.751,1.3,8.361,8.361,0,1,1-1.716,1.315.75.75,0,1,0-1.058-1.063,9.847,9.847,0,1,0,6.946-2.867Z" />
        <path fill="#1a1a1a" d="M27.393 39.268H25.51A1.108 1.108 0 0 1 24.4 38.161a.75.75 0 0 0-1.5 0 2.61 2.61 0 0 0 2.607 2.607H25.7v1.438a.75.75 0 0 0 1.5 0V40.768h.191a2.607 2.607 0 0 0 0-5.214H25.51a1.108 1.108 0 0 1 0-2.215h1.883A1.108 1.108 0 0 1 28.5 34.446a.75.75 0 0 0 1.5 0 2.61 2.61 0 0 0-2.607-2.607H27.2V30.4a.75.75 0 0 0-1.5 0v1.439H25.51a2.608 2.608 0 0 0 0 5.215h1.883a1.107 1.107 0 0 1 0 2.214zM44.417 15.637a.75.75 0 0 0-.4 1.445c2.029.564 2.486 1.2 2.486 1.372 0 .626-2.935 2.094-8.625 2.094s-8.626-1.468-8.626-2.094 2.934-2.094 8.626-2.094a27.333 27.333 0 0 1 4.023.283.751.751 0 0 0 .221-1.485 29.106 29.106 0 0 0-4.244-.3c-4.877 0-10.126 1.125-10.126 3.594v5.835c0 2.469 5.249 3.594 10.126 3.594 3.278 0 6.718-.511 8.625-1.595v.918c0 .626-2.935 2.094-8.625 2.094-.653 0-1.289-.02-1.9-.06a.758.758 0 0 0-.8.7.749.749 0 0 0 .7.8c.645.042 1.314.064 2 .064 3.278 0 6.718-.511 8.625-1.6v.918c0 .626-2.935 2.1-8.625 2.1l-.247 0c-.042 0-.066 0-.2 0a.779.779 0 0 0-.772.727.752.752 0 0 0 .728.773c.1 0 .163 0 .205 0l.1 0 .194 0c3.278 0 6.718-.512 8.625-1.6v.918c0 .626-2.935 2.094-8.625 2.094a.75.75 0 0 0 0 1.5c3.278 0 6.718-.512 8.625-1.595v.991c0 .626-2.935 2.094-8.625 2.094h-.269a.794.794 0 0 0-.758.742.751.751 0 0 0 .742.758h.285C42.751 39.625 48 38.5 48 36.031V18.454C48 17.624 47.378 16.462 44.417 15.637zm-6.542 6.411c3.278 0 6.718-.511 8.625-1.595v.918c0 .626-2.935 2.1-8.625 2.1s-8.626-1.469-8.626-2.1v-.918C31.156 21.537 34.6 22.048 37.875 22.048zm0 4.335c-5.692 0-8.626-1.468-8.626-2.094v-.918c1.907 1.084 5.346 1.6 8.626 1.6s6.718-.511 8.625-1.6v.918C46.5 24.915 43.565 26.383 37.875 26.383zM15.8 40.28c-.264.01-.53.016-.8.016-7.95 0-13.5-4.561-13.5-11.091 0-5.325 3.6-13.2 8.969-16.435.073-.045.134-.1.2-.15H16.8a.75.75 0 0 0 0-1.5H11.615a2.25 2.25 0 0 0-.326-1.626C8.754 5.567 8.261 3.8 8.353 3.342a.053.053 0 0 0 .032.007 11.7 11.7 0 0 1 3.323.506 11.594 11.594 0 0 0 3.214.5 15.118 15.118 0 0 0 3.643-.538 13.576 13.576 0 0 1 2.883-.468c-.027.565-.587 2.234-2.524 5.54H13.2a.75.75 0 0 0 0 1.5h5.062a2.234 2.234 0 0 0 .048.837 2.409 2.409 0 0 0 1.133 1.486 18.354 18.354 0 0 1 6.348 7.069.75.75 0 1 0 1.317-.717 19.853 19.853 0 0 0-6.9-7.643.927.927 0 0 1-.443-.563.76.76 0 0 1 .091-.591c3.764-6.262 3.156-7.337 2.9-7.8a1.253 1.253 0 0 0-1.132-.625 14.31 14.31 0 0 0-3.4.511 13.742 13.742 0 0 1-3.3.5 10.2 10.2 0 0 1-2.83-.453 13.307 13.307 0 0 0-3.707-.556 1.425 1.425 0 0 0-1.335.725c-.252.463-.922 1.693 2.979 7.735a.759.759 0 0 1 .109.6.932.932 0 0 1-.444.581C3.9 14.982 0 23.471 0 29.205 0 36.5 6.31 41.8 15 41.8q.432 0 .858-.018a.75.75 0 1 0-.059-1.5z" />
      </g>
    </>
  ),

  // Análise - Dashboard com analista e gráficos
  analysis: () => (
    <>
      {/* Gráfico circular */}
      <circle fill="#a3cef1" cx="17.625" cy="6.375" r="4.875"/>
      {/* Pessoa analista */}
      <path fill="#dda15e" d="M9.968,14.265l-1.125,0.484c-0.379,0.161-0.806,0.161-1.181,0l-1.125-0.484c-0.551-0.236-0.907-0.78-0.907-1.38v-2.01c0-1.241,1.008-2.25,2.25-2.25h0.75c1.241,0,2.25,1.009,2.25,2.25v2.01c0,0.6-0.356,1.144-0.907,1.38Z"/>
      {/* Corpo */}
      <path fill="#274c77" d="M13.178,16.5c-0.682-0.694-1.631-1.125-2.678-1.125h-1.125c0,0.622-0.503,1.125-1.125,1.125s-1.125-0.503-1.125-1.125h-1.125c-2.07,0-3.75,1.68-3.75,3.75v2.625h6l1.5-5.25h1.178Z"/>
      {/* Cabeça */}
      <path fill="#274c77" d="M10.875,11.393c-.214-.086-.461-.143-.774-.143-1.624,0-1.624,1.5-3.251,1.5-.424,0-.739-.101-.998-.251v-.124c0-1.241,1.008-2.25,2.25-2.25h0.75c.889,0,.656.518,2.023,1.268Z"/>
      {/* Barras do gráfico */}
      <polygon fill="#8b8c89" points="10.5,21.75 12,16.5 20.25,16.5 18.75,21.75"/>
      {/* Gráfico de barras verticais */}
      <path fill="#274c77" d="M20.25,7.875v-3.375h-0.75v3.375h-0.75v-1.875h-0.75v1.875h-0.75v-2.625h-0.75v2.625h-0.75v-1.125h-0.75v1.125h-0.75v0.75h6.75v-0.75h-0.75Z"/>
      {/* Linha do gráfico */}
      <path fill="#f76c5e" d="M15.225,5.55l-0.45-0.6,1.5-1.125c0.112-0.086,0.266-0.098,0.394-0.034l1.286,0.641,1.688-1.35,0.469,0.585-1.875,1.5c-0.116,0.09-0.27,0.109-0.401,0.041l-1.294-0.645-1.316,0.987Z"/>
      {/* Detalhes adicionais */}
      <circle fill="#6096ba" cx="16.5" cy="13.875" r="0.75"/>
      <circle fill="#6096ba" cx="15" cy="15.375" r="0.75"/>
    </>
  ),

  // Pricing — etiqueta de preço com furo, margem % e seta de valor
  pricing: () => (
    <>
      {/* Etiqueta com furo (price tag) */}
      <path
        d="M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.84z"
        fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Furo da etiqueta */}
      <circle cx="6.5" cy="6.5" r="1" fill="currentColor" />
      {/* Símbolo % (margem) */}
      <circle cx="9.5" cy="14.5" r="1" fill="none" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="14.5" cy="9.5" r="1" fill="none" stroke="currentColor" strokeWidth="1.3" />
      <line x1="10" y1="14" x2="14" y2="10" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </>
  ),
}

// ViewBox por contexto — use um viewBox maior para ícones que usam coordenadas maiores
// Use Partial so we only need to define contexts that differ from the default
const contextViewBoxes: Partial<Record<UnitContext, string>> = {
  billing: '0 0 48 48',
}

export function ContextIcon({ context, className = '' }: ContextIconProps) {
  const iconFn = contextIcons[context] || contextIcons.unit // Fallback para 'unit' se contexto não encontrado
  const viewBox = contextViewBoxes[context] ?? '0 0 24 24'
  return (
    <svg className={className} fill="currentColor" viewBox={viewBox} preserveAspectRatio="xMidYMid meet">
      {iconFn()}
    </svg>
  )
}

export function getContextIcon(context: UnitContext): JSX.Element {
  const iconFn = contextIcons[context] || contextIcons.unit;
  return iconFn();
}
